module.exports = __webpack_public_path__ + "static/media/bg_top.f5a01a1e.svg";